import React from "react";

interface PlanSelectFieldProps {
  value: "basic" | "startup";
  onChange: (v: "basic" | "startup") => void;
  period: "annual" | "monthly";
}

const PlanSelectField: React.FC<PlanSelectFieldProps> = ({
  value,
  onChange,
  period,
}) => {
  const prices = {
    basic: {
      annual: 32,
      monthly: 3,
    },
    startup: {
      annual: 130,
      monthly: 12,
    },
  };
  return (
    <div className="text-center">
      <div className="grid grid-cols-2 gap-6">
        <div
          className={`border-2 ${
            value === "basic" ? "border-gray-400" : "border-gray-500"
          }  rounded-xl hover:border-gray-400 cursor-pointer p-5`}
          onClick={() => onChange("basic")}
        >
          <div className="bg-gray-500 w-20 text-xs p-1 rounded-full mx-auto mb-2">
            Basic
          </div>
          <div className="text-5xl font-semibold mt-4 flex items-center justify-center">
            £<span className="block mt-3">{prices.basic[period]}</span>
          </div>
          <div className="text-xs text-gray-400">
            / {period === "annual" ? "year" : "month"}
          </div>
        </div>
        <div
          className={`border-2 ${
            value === "startup" ? "border-gray-400" : "border-gray-500"
          }  rounded-xl hover:border-gray-400 cursor-pointer p-5`}
          onClick={() => onChange("startup")}
        >
          <div className="bg-gray-500 w-20 text-xs p-1 rounded-full mx-auto mb-2">
            Startup
          </div>
          <div className="text-5xl font-semibold mt-4 flex items-center justify-center">
            £<span className="block mt-3">{prices.startup[period]}</span>
          </div>
          <div className="text-xs text-gray-400">
            / {period === "annual" ? "year" : "month"}
          </div>
        </div>
      </div>
      <a
        className="mt-4 text-sm font-medium block hover:text-secondary"
        href="https://appsicle.co/pricing"
        target="_blank"
        rel="noreferrer noopener"
      >
        View Plan Details
      </a>
    </div>
  );
};

export default PlanSelectField;
